import React, {Component} from "react";
import LinksContainer from "../../components/linkelement/LinksContainer";
import LinkCard from "../../components/linkelement/LinkCard";

class GemLinksAusschuss extends Component {

  render() {

    return <LinksContainer mainTagTitle='Gäste' title='Freikirche der Siebenten-Tags-Adventisten Gemeinde Langau i.E.' width='90px' subtitle='Zugang zu Medien und Veranstalltungen — Wähle eine Kachel.'>
      <LinkCard link='https://cloud.adventisten.ch/s/xKETMmy457A263R' numOfColumns='2' title='Gäste' subtitle='Bereich Gäste' description='Hier findest du den Bereich für die Gäste.' />
    </LinksContainer>;
  }
}

export default GemLinksAusschuss;
